import { OperatingAreaApi } from 'api-typings/users/users';
import { OperatingArea } from './operating-areas.model';

export function transformOperatingArea(
  operatingAreaApi: OperatingAreaApi,
): OperatingArea {
  return {
    id: operatingAreaApi.id,
    type: operatingAreaApi.type,
    street: operatingAreaApi?.street,
    postcode: operatingAreaApi?.postcode,
    city: operatingAreaApi?.city,
    stateLongName: operatingAreaApi?.state_long_name,
    stateShortName: operatingAreaApi?.state_short_name,
    countryCode: operatingAreaApi?.country_code,
  };
}
